// import React from "react";
// import "./signup.css";
// import HeadingComp from "./HeadingComp";
// import axios from "axios";
// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { authActions } from "../../store";

// const URI= process.env.REACT_APP_API_URL;

// const SignIn = () => {
//   const dispatch = useDispatch();
//   const history = useNavigate();
//   const [Inputs, setInputs] = useState({
//     email: "",
//     password: "",
//   });
//   const change = (e) => {
//     const { name, value } = e.target;
//     setInputs({ ...Inputs, [name]: value });
//   };
//   const submit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         // `https://task-management-mern-five.vercel.app/api/auth/login`,
//         `${URI}api/auth/login`,
//         Inputs
//       );
//       console.log(response.data);
//       if (response.data) {
//         // sessionStorage.setItem("id", response.data.user._id);
//         localStorage.setItem('token', response.data.token);
//         localStorage.setItem('user', response.data.name);
//         localStorage.setItem('email', response.data.email);
//         dispatch(authActions.login());
//         history("/todo");
//       } else {
//         // Handle the case where the response does not contain the expected data
//         console.error("Response data or _id not found in the response.");
//       }
//     } catch (error) {
//       // Handle any errors that occurred during the HTTP request
//       console.error("An error occurred:", error);
//       alert(`An error occurred: ${error.response.data.error}`);
//     }
//   };

//   return (
//     <div>
//       <div className="signup">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-4 column col-left d-none d-lg-flex justify-content-center align-items-center">
//               <HeadingComp first="Sign" second="In" />
//             </div>
//             <div className="col-lg-8 column d-flex justify-content-center align-items-center ">
//               <div className="d-flex flex-column  w-100 p-3">
//                 <input
//                   className="p-2  my-3 input-signup"
//                   type="email"
//                   name="email"
//                   placeholder="Enter Your Email"
//                   value={Inputs.email}
//                   onChange={change}
//                 />

//                 <input
//                   className="p-2 my-3 input-signup"
//                   type="password"
//                   name="password"
//                   placeholder="Enter Your Password"
//                   value={Inputs.password}
//                   onChange={change}
//                 />

//                 <button className="btn-signup p-2" onClick={submit}>
//                   Sign In
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignIn;


import React, { useState } from "react";
import "./signup.css";
import HeadingComp from "./HeadingComp";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authActions } from "../../store";

const URI = process.env.REACT_APP_API_URL;

const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Renamed for clarity
  const [Inputs, setInputs] = useState({
    email: "",
    password: "",
  });

  const change = (e) => {
    const { name, value } = e.target;
    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${URI}api/auth/login`,
        Inputs
      );
      console.log(response.data);
      if (response.data) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', response.data.name);
        localStorage.setItem('email', response.data.email);
        dispatch(authActions.login());
        navigate("/todo"); // Using the renamed `navigate`
      } else {
        console.error("Response data or _id not found in the response.");
      }
    } catch (error) {
      console.error("An error occurred:", error);
      alert(`An error occurred: ${error.response.data.error}`);
    }
  };

  return (
    <div className="signup">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 column col-left d-none d-lg-flex justify-content-center align-items-center">
            <HeadingComp first="Sign" second="In" />
          </div>
          <div className="col-lg-8 column d-flex justify-content-center align-items-center">
            <div className="d-flex flex-column w-100 p-3">
              <input
                className="p-2 my-3 input-signup"
                type="email"
                name="email"
                placeholder="Enter Your Email"
                value={Inputs.email}
                onChange={change}
              />
              <input
                className="p-2 my-3 input-signup"
                type="password"
                name="password"
                placeholder="Enter Your Password"
                value={Inputs.password}
                onChange={change}
              />
              <button className="btn-signup p-2" onClick={submit}>
                Sign In
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;

